import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Pricing from "../components/Pricing"; // adjust path if needed

export default function GetStartedPage() {
  const navigate = useNavigate();

  return (
    <div className="pt-16 min-h-screen bg-gray-50">
      {/* Back bar — minimal vertical space, sits tight against the navbar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-3 pb-1">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors text-sm font-semibold group"
        >
          <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform duration-200" />
          Back to Home
        </button>
      </div>

      {/* Tight top padding here — Home page usage keeps its own larger spacing
          by calling <Pricing /> with no prop, defaulting to py-20 */}
      <Pricing sectionClassName="pt-3 pb-20" />
    </div>
  );
}